import { render } from "./DemandRegister.vue?vue&type=template&id=2301654e&ts=true"
import script from "./DemandRegister.vue?vue&type=script&lang=ts"
export * from "./DemandRegister.vue?vue&type=script&lang=ts"

import "./DemandRegister.vue?vue&type=style&index=0&id=2301654e&lang=css"

import exportComponent from "/builds/weleaf/twd-origination-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QInput from 'quasar/src/components/input/QInput.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QSpinnerFacebook from 'quasar/src/components/spinner/QSpinnerFacebook.js';
import QExpansionItem from 'quasar/src/components/expansion-item/QExpansionItem.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QStepper from 'quasar/src/components/stepper/QStepper.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QInput,QBtn,QTooltip,QSpinnerFacebook,QExpansionItem,QSelect,QStepper});
